import {useQuery} from "react-query";
import apiService from "../../../../../../../api/apiService";
import BluePrintCategoriesRow from "./BluePrintCategoriesRow";


const ThirdStep = () => {
    const {data: getBlueprintsData} = useQuery("blueprints", () =>
        apiService.getBlueprints()
    );

    return (
        <BluePrintCategoriesRow bpData={getBlueprintsData}/>
    );
}

export default ThirdStep;
